import React, { useEffect, useState } from "react";
import * as core from "@material-ui/core";
import { useTranslation } from "react-i18next";
import axios from "axios";

const ClientInfoByGuest = (props) => {
  const { touched, errors, values, handleBlur, handleChange, setFieldValue, } = props;
  const { t } = useTranslation();

  const handleCountryChange = (event) => {
    setFieldValue("workerDemanderDetails.oneAddressSave.countryCode", event.target.value);
    getResult(event.target.value+"Cities");
  };

  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  
  const getResult = async (metadataGroup) => {
    const result = await axios.get(`http://localhost:5001/api/Management/get_metadata_values?metadataGroup=${metadataGroup}`);    
    var data = [{ metadataCode: "", metadataValue: "Select" }];
    
    result.data.data.map((rc) => {
      data.push({
        metadataCode: rc.metadataCode,
        metadataValue: rc.metadataValue,
      });
    });
    
    if (metadataGroup === "Country") {
      setCountryList(data);
    } else {
      setCityList(data)
    }
  };

  useEffect(() => {  
    const getResult2 = async () => {
      await getResult("Country");
    };

    getResult2();
  }, []);

  
  return (
    <core.Card>
      <core.CardHeader title={t("pages.workrequest.clientInfoByGuest.stepname")} />

      <core.Divider />
      <core.CardContent>
        <core.Grid container spacing={1}>
          <core.Grid item md={6} xs={12}>
            <core.TextField fullWidth
             InputLabelProps={{shrink: true,}}
              label={t("workerDemander.firmName")}
              name="workerDemanderDetails.firmName"
              error={Boolean(touched.workerDemanderDetails?.firmName && errors.workerDemanderDetails?.firmName)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.workerDemanderDetails?.firmName} />
          </core.Grid>
          <core.Grid item md={6} xs={12}>
            <core.TextField fullWidth
             InputLabelProps={{shrink: true,}}
              label={t("workerDemander.firstName")}
              name="workerDemanderDetails.firstName"
              error={Boolean(touched.workerDemanderDetails?.firstName && errors.workerDemanderDetails?.firstName)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.workerDemanderDetails?.firstName} />
          </core.Grid>
          <core.Grid item md={6} xs={12}>
            <core.TextField fullWidth
             InputLabelProps={{shrink: true,}}
              label={t("workerDemander.lastName")}
              name="workerDemanderDetails.lastName"
              error={Boolean(touched.workerDemanderDetails?.lastName && errors.workerDemanderDetails?.lastName)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.workerDemanderDetails?.lastName} />
          </core.Grid>
          <core.Grid item md={6} xs={12}>
            <core.TextField fullWidth
             InputLabelProps={{shrink: true,}}
              label={t("workerDemander.privatePhoneNumber")}
              name="workerDemanderDetails.privatePhoneNumber"
              error={Boolean(touched.workerDemanderDetails?.privatePhoneNumber && errors.workerDemanderDetails?.privatePhoneNumber)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.workerDemanderDetails?.privatePhoneNumber} />
          </core.Grid>
          <core.Grid item md={6} xs={12}>
            <core.TextField fullWidth
             InputLabelProps={{shrink: true,}}
              label={t("workerDemander.emailAddress")}
              name="workerDemanderDetails.emailAddress"
              error={Boolean(touched.workerDemanderDetails?.emailAddress && errors.workerDemanderDetails?.emailAddress)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.workerDemanderDetails?.emailAddress} />
          </core.Grid>
          <core.Grid item md={6} xs={12}>
            <core.TextField fullWidth
              label={t("address.countryCode")}
              name="workerDemanderDetails.oneAddressSave.countryCode"
              select
              SelectProps={{ native: true }}
              InputLabelProps={{shrink: true,}}
              error={Boolean(touched.workerDemanderDetails?.oneAddressSave?.countryCode && errors.workerDemanderDetails?.oneAddressSave?.countryCode)}
              onBlur={handleBlur}
              onChange={handleCountryChange}
              value={values.workerDemanderDetails?.oneAddressSave?.countryCode}>
              {countryList?.map((option) => (
                <option key={option.metadataCode} value={option.metadataCode}>
                  {option.metadataValue}
                </option>
              ))}
            </core.TextField>
          </core.Grid>
          <core.Grid item md={6} xs={12}>
            <core.TextField
              fullWidth
              label={t("address.city")}
              name="workerDemanderDetails.oneAddressSave.city"
              select
              SelectProps={{ native: true }}
              InputLabelProps={{shrink: true,}}
              error={Boolean(touched.workerDemanderDetails?.oneAddressSave?.city && errors.workerDemanderDetails?.oneAddressSave?.city)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.workerDemanderDetails?.oneAddressSave?.city}>
              {cityList?.map((option) => (
                <option key={option.metadataCode} value={option.metadataCode}>
                  {option.metadataValue}
                </option>
              ))}
            </core.TextField>
          </core.Grid>
          <core.Grid item md={6} xs={12}>
            <core.TextField
              fullWidth
              InputLabelProps={{shrink: true,}}
              label={t("address.postCode")}
              name="workerDemanderDetails.oneAddressSave.postCode"
              error={Boolean(touched.workerDemanderDetails?.oneAddressSave?.postCode && errors.workerDemanderDetails?.oneAddressSave?.postCode)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.workerDemanderDetails?.oneAddressSave?.postCode}
            />
          </core.Grid>
          <core.Grid item md={6} xs={12}>
            <core.TextField
              fullWidth
              InputLabelProps={{shrink: true,}}
              label={t("address.detail")}
              name="workerDemanderDetails.oneAddressSave.detail"
              error={Boolean(touched.workerDemanderDetails?.oneAddressSave?.detail && errors.workerDemanderDetails?.oneAddressSave?.detail)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.workerDemanderDetails?.oneAddressSave?.detail}
            />
          </core.Grid>
        </core.Grid>
      </core.CardContent>

      {/* Master state
      <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
    </core.Card>
  );
};

export default ClientInfoByGuest;
